export default {
  app: {
    title: "",
  },
  refresh: {
    title: "Are you active?",
    cta: "You were registered as not active, please confirm that you are active in the next minute, if you don't you will be logged out.",
  },
  common: {
    language: "Language",
    english: "English",
    serbian: "Serbian",
    close: "Close",
    dataGridExample: "Data Grid Example",
    trademark: "TM",
    search: "Search",
    error: "Error",
    continue: "Continue",
    labelUsername: "Username",
    labelEmail: "Email",
    labelPassword: "Password",
    next: "Next",
    nextPage: "Next page",
    previousPage: "Previous page",
    back: "Back",
    goBack: "Go Back",
    ok: "Ok",
    done: "Done",
    confirm: "Confirm",
    printDownload: "Print/Download",
    cancel: "Cancel",
    remove: "Remove",
    invite: "Invite",
    save: "Save",
    complete: "Complete",
    download: "Download",
    yes: "Yes",
    no: "No",
    to: "to",
    select: "Select...",
    none: "None",
    date: {
      range: "{{start}} to {{end}}",
    },
    apply: "Apply",
    joinUs: "Join Us",
  },
  pageTitles: {
    Home: "Home Page | Tremium Software",
    About: "About Us | Tremium Software",
    Career: "Career Page | Tremium Software",
    OurWork: "Our Projects & Case Studies",
  },
  pages: {
    home: "Home",
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot password",
    error: "Error",
    notFound: "Not Found",
    profile: "Profile",
    settings: "Settings",
    dashboard: "Dashboard",
    about: "About",
    careers: "Careers",
    contact: "Contact",
    ourWork: "Our work",
    caseStudies: "Case Studies",
    howWeCanHelp: "For Clients",
    openPositions: "We are hiring",
  },
  register: {
    registerTitle: "Register",
    usernameRequired: "Username is required.",
    emailFormat: "Invalid email address format.",
    emailRequired: "An email or username is required.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    passwordRequired: "A Password is required.",
  },
  login: {
    welcome: "React template",
    dontHaveAccount: "Don't have an account? ",
    emailFormat: "Invalid email address format.",
    emailRequired: "An email or username is required.",
    noUsers: "There are no users with that email.",
    passwordStrength: "Your password is {{strength}}.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    signUpRecommendation: "Sign up",
    email: "Please enter your email address or username to log in:",
    logInTitle: "Log In",
    logIn: "Log In",
    signUp: "Sign Up",
    usernameRequired: "Username is required.",
    passwordRequired: "A Password is required.",
    forgotYourPassword: "Forgot your password?",
    forgotPasswordEmail: "Email",
    useDifferentEmail: "Use different email address or username",
  },
  password: {
    weak: "weak",
    average: "average",
    good: "good",
    strong: "strong",
  },
  forgotPassword: {
    title: "Forgot Password",
    label: "Send email",
    emailRequired: "An email is required.",
    emailFormat: "Invalid email address format.",
    forgotPassword: {
      title: "Forgot Password",
      subtitle:
        "Please answer the security question to gain access to your account:",
      label: "Reset Password",
    },
  },
  notFound: {
    text: "We're sorry but we couldn't find the page you were looking for.",
    goBack: "Go back to homepage",
  },
  errorPage: {
    text: "We're sorry, an internal server error came up. Please be patient or try again later.",
    goBack: "Go back to homepage",
    logout: "Logout",
  },
  apiErrors: {
    ClientIpAddressIsNullOrEmpty: "Client Ip address is null or empty",
    UsernameDoesNotExist: "Username does not exist",
    WrongCredentials: "Wrong credentials",
    SomethingWentWrong: "Something went wrong",
    WrongPasswordAccountIsLocked: "Wrong credentials, account is locked",
    AccountIsLocked: "Account is locked",
  },
  homePage: {
    intro: {
      header:
        "<1>Developing Software</1> <1><0>Boldly</0> Beyond</1> <1>Boundaries</1>",
      text: "We are a team of IT professionals who <0>boldly</0> bring ideas to life by creating innovative digital platforms and offering excellent technical support.",
      items: {
        item1: { header: "Client Retention", text: "100%" },
        item2: { header: "Employees", text: "40+" },
        item3: { header: "Projects", text: "15+" },
      },
      breadcrumb: "<0>Team</0><0>Trust</0><0>Technology</0>",
      button: "Contact us ",
    },
    paragraf1: {
      header: "Our <0>Services</0> Lineup",
      items: {
        item1: {
          header: "<2>Software</2> <2>Development <br /> <0>Outsourcing<0></2>",
          text: "We develop <0>cutting-edge custom software</0> applications, mobile apps, or websites for our partners, providing them with sustainable and adaptable digital solutions.",
        },
        item2: {
          header: "<2>Software</2><2>Testing & <0>QA</0></2>",
          text: "We provide a <0>complete range of software testing</0> services while keeping partners' satisfaction at its core. You can be sure your product meets high-quality standards.",
        },
        item3: {
          header: "<2>Web</2> <2><0>Development</0></2>",
          text: "We help you <0>streamline business</0> processes while leveraging reliable and secure development approaches. We create fully functional and visually appealing digital solutions. ",
        },
        item4: {
          header: "<2>Mobile</2> <2><0>Development</0></2>",
          text: "Our mobile app development expertise can offer you <0>full life cycle</0> management for iOS, Android, and Hybrid-based applications from prototyping to deployment and testing.",
        },
        item5: {
          header: "<2><0>DevOps</0></2>",
          text: "We have the technical abilities and knowledge to assist your team in transitioning to a <0>DevOps development and delivery</0> strategy. We write the scripts required to automate the workflow and offer security and performance suggestions and implementation.",
        },
        item6: {
          header: "<2>IT</2><2><0>Consulting</0> <br/> Service</2>",
          text: "We provide <0>expert advice and strategic guidance</0> on IT-related decisions, including technology adoption, system upgrades, data analyses, business analyses, and digital transformation initiatives.",
        },
        item7: {
          header: "<2>IT</2> <2>Project </2> <2><0>Management</0></2>",
          text: "Our Project Managers coordinate IT projects from <0>inception to completion</0>, ensuring they are delivered on time, within budget, and according to specifications.",
        },
        item8: {
          header: "<2><0>AI</0></2> <2>Development</2>",
          text: "Our team leverages <0>advanced machine learning</0> algorithms and neural networks to create scalable AI applications.",
        },
        item9: {
          header: "<2><0>Power BI</0><2/>",
          text: "Unlock the power of your data with captivating visuals! <0>Our team specializes</0> in leveraging Power BI to craft interactive reports that transform raw data into meaningful insights.",
        },
        item10: {
          header: "<2>Azure <br/>Data</2> <2><0>Factory</0></2>",
          text: "Our expertise lies in utilizing Azure Data Factory as a <0>sophisticated tool</0> for defining ETL workflows with precision and expertise, thereby harnessing its full potential for streamlined data integration.",
        },
      },
    },
    paragraf2: {
      header: "<0>Expert</0> Tech Stack",
    },
    paragraf3: {
      header: "Industries We <0>Excell</0> At",
      items: {
        item1: "FinTech",
        item2: "Healthcare",
        item3: "Trading",
        item4: "Transport",
        item5: "Booking",
      },
    },
    paragraf4: {
      header: "<0>Agile Process</0> That<br /> Defines Us",
      text: `“Agile methodology is an iterative approach to software development that emphasizes flexibility, collaboration, and continuous improvement.”`,
      items: {
        item1: {
          header: "Vision Crafting",
          text: "We create Personas, Journey Mapping, and Usability Testing to understand your user base better.",
        },
        item2: {
          header: "Innovation Blueprinting",
          text: "Our design team creates system flows, journey maps, annotated wireframes, final UI designs, and click-model prototypes.",
        },
        item3: {
          header: "Code Artistry",
          text: "After deciding on a strategy, we proceed with secure frontend, backend, and full-stack development.",
        },
        item4: {
          header: "QA Performance",
          text: "Our code is scalable, reusable, readable, and high-performing.",
        },
        item5: {
          header: "Launch Elevation",
          text: "We are prepared to launch after all sprints have ended and User Acceptance Testing (UAT) has been successful.",
        },
      },
    },
    paragraf5: {
      header: "Something from<br /> Our <0>Clients</0>",
      items: {
        item1: {
          persion: {
            name: "Peter Custer",
            position: "CTO at GBI",
          },
          text: "The team at Tremium is knowledgeable, experienced, and just as importantly, dependable and engaged. They've always been there when I've needed them, never leaving me stranded (even nights and weekends when necessary). They are a group of professionals who really know their stuff. My relationship with them spans over 12 years, during which I've come to rely on their dedication, support, and wealth of expertise. I can recommend them without any hesitation.",
        },
        item2: {
          persion: {
            name: "Saša Milosavljević",
            position: "Manager at BP Consulting",
          },
          text: "We have been fostering a friendship with the Tremium team for a long time, which we strengthened by working together on a fantastic project. The idea for the project came from our desire to simplify day-to-day tasks. The Tremium team took that idea and improved it with their knowledge and skills to create a feature-rich and truly helpful application. We highly recommend this team of professionals!",
        },
        item3: {
          persion: {
            name: "Božidar Ignjatović",
            position: "CEO at Badin Soft",
          },
          text: "Velja and Tripko are my old and reliable partners. We've been working together for more than a decade. Highly skilled professionals for any assigned job. Do not hesitate if you need support, Tremium brings additional value. They are not only a tech team, they'll be partners to your business as they were for ours!",
        },
        item4: {
          persion: {
            name: "Adis Terzić",
            position: "Niš Ekspres",
          },
          text: 'Tremium team helped us to build and integrate several parts of the existing Information System with multiple integration points and enabled fieldwork. In the work process, they come forward with comments and questions that eventually bring additional value to the product. Be assured that you can always count on the highest performance from Tremium, "around-the-clock" support, and have a partner for your business.',
        },
        item5: {
          persion: {
            name: "Jimmie Antonsson",
            position: "Project Owner at Travel Support",
            positionSm: "Project Owner,<br /> Travel Support",
          },
          text: "We are really satisfied with the high-quality relationship that we have built with the Tremium team through the years. They have helped us optimize and realize important projects with their ideas, dedication, and committed work. With them, we can say with confidence that the entire process runs smoothly, from idea to execution.",
        },
        item6: {
          persion: {
            name: "Asseco team",
          },
          text: "The Tremium team provided invaluable assistance during a crucial moment, guaranteeing the effectiveness of a project of considerable importance. Through their proactive approach and bold ideas, they contributed to the conceptual solution of the project itself. It is our pleasure to collaborate with such a team of professionals!",
        },
      },
    },
    paragraf6: {
      header: "Explore our <0>Domain</0>",
    },
  },
  aboutPage: {
    title: "Boldness <br /> <0>Beyond Boundaries</0>",
    intro:
      "By the end of 2023, we began on an exciting journey and founded Tremium Software with the aim and purpose of building a team of professionals who will boldly embark on the development of innovative ideas. The result is a business that fosters each employee's <0>potential for growth</0>, places a strong emphasis on building enduring relationships with clients and family values, and works tirelessly to have a positive impact on the community.",
    Mission1Title: "Our <0>Mission</0> and <1>Promise</1>",
    Mission2Title: "We <0>Stand For</0>",
    mission1:
      "Our mission is to create <0>lasting partnerships</0> with clients through innovative digital solutions, prioritizing deep understanding and tailored excellence. We build relationships based on trust, transparency, and effective communication, fostering a collaborative and creative work culture for our colleagues.",
    mission2:
      "Envisioning ourselves as a leading local IT company, we aim to set industry standards and actively contribute to developing the local and global IT community. We aspire to be a <0>socially responsible</0> entity, leveraging technology to address societal challenges and leaving a meaningful legacy through continuous innovation, ethical practices, and community engagement. Our overarching goal is to positively contribute to the well-being of the communities we serve.",
    commitmentTitle: "We <0>Stand For</0>",
    commitment1Title: "Long - standing <0></0>relationship",
    commitment1:
      "Culture that cultivates trust, understanding, loyalty, open communication, and contribution to create relationships that stand the test of time",
    commitment2Title: "Striving for <0></0>excellence",
    commitment2:
      "Culture of courage, risk-taking, and pushing beyond boundaries through creative thinking in processes, ideas, organizational structure, and corporate culture.",
    commitment3Title: "Boldness",
    commitment3:
      "Culture of curiosity, adaptability, and a willingness to invest in the growth of individuals.",
    commitment4Title: "Committed to <0></0>people",
    commitment4:
      "Culture of respect, diversity, and teamwork, where each of us feels valued and has the opportunity to reach our full potential.",
    ourTeam: {
      Core: {
        Title: "Our <0>Core</0> Team",
        Velimir: "Velimir Đorđević",
        Milos: "Miloš Mandić",
        Milan: "Milan Tripković",
        Role: "CO-FOUNDER",
      },
      Business: {
        Title: "Our <0>Business</0> Partners",
        Milan: "Milan Đorđević",
        Miljan: "Miljan Stefanović",
        Marko: "Marko Đurović",
        Strahinja: "Strahinja Đurković",
        Dunja: "Dunja Stevanović",
        Role: "Business Partner & Technical Team Lead",
      },
      People: {
        Title: "Our <0>People</0> Team",
        Vesna: {
          Name: "Vesna Kostić",
          Role: "HR Manager",
        },
        SaraMancic: {
          Name: "Sara Mančić",
          Role: "Employer Branding & Marketing Manager",
        },
        Dusan: {
          Name: "Dušan Dimić",
          Role: "Legal & Finance Manager",
        },
      },
      Technical: {
        Title: "Our <0>Tech</0> Team",
      },
    },
  },
  careersPage: {
    intro: {
      header: "Work (Delight) @ <0>Tremium</0>",
      text: "We are <0>a team</0> of IT professionals who strive to build a caring, bold, and powerful culture that makes a difference.",
      button: "See open positions",
    },
    paragraf1: {
      header: "Benefits",
      card1: {
        header: "Bread and Butter",
        text: `<ul>
                  <li>Flexible working hours</li>
                  <li>Hybrid working environment</li>
                  <li>Modern office</li>
                  <li>Competitive financial conditions</li>
                  <li>Lunch</li>
              </ul>`,
      },
      card2: {
        header: "Backbone",
        text: `<ul> 
                  <li>Private health insurance</li>
                  <li>Sick day</li>
                  <li>Additional free days per seniority</li>
                  <li>Childbirth bonuses</li>
                  <li>Wedding bonuses</li>
              </ul>`,
      },
      card3: {
        header: "Lifeblood",
        text: `<ul>
                  <li>Mentorship programs</li>
                  <li>Career development program</li>
                  <li>Educational meetups</li>
                  <li>Conferences & events (both as a participant and speaker)</li>
                  <li>Soft skills training</li>
                  <li>Books & e-books</li>
              </ul>`,
      },
      card4: {
        header: "Driving force",
        text: `<ul>
                  <li>Team-building trip</li>
                  <li>Themed parties</li>
                  <li>Weekly team-building activities</li>
                  <li>Family activities</li>
              </ul>`,
      },
    },
    paragraf2: {
      header: "Culture",
      items: {
        item1:
          "Our bold dedication lies in providing a supportive and creative atmosphere where every idea and opinion is valued. We developed a <0>unique career</0> development program for our colleagues to create an environment where they can learn, grow, and progress professionally. From the beginning, you can expect to find a balance between educational support, quality progress, and team-building activities.",
        item2:
          "We are particularly committed to strengthening family values because we are aware that the stud family is a support for all our colleagues. That is the reason we have developed a unique program of <0>family-friendly</0> events and benefits. We have provided special bonuses for wedding days, childbirth, and starting school season. A few times a year we organize family trips, climbing, and skiing. Holiday celebrations with the youngest members of the Tremium team are the most enjoyable parties in Tremium Software.",
        item3:
          "We place a high value on mental health care, which is why our team of professionals plans events that provide the ideal balance between professional and personal life. We encourage teamwork wherever possible, which also makes it essential for us to provide monthly events for team building and team bonding. Our team gets to engage in <0>various activities</0> during the workweek, such as playing darts or pool, getting together for a sing-along with a guitar, visiting cinemas, and enjoying delicious food at Niš kafana.",
      },
    },
    paragraf3: {
      header: "<0>Selection</0> Process",
      items: {
        item1: {
          header: "Application Submission",
          text: "This is where the adventure begins! If you believe that Tremium Software is the place where you can enjoy the adventure, we are more than trill to meet you. All of our open positions are listed on our website. Be bold and send us your resume.<br/><br/>Need more information? Contact us!",
        },
        item2: {
          header: "Resume Review",
          text: "Your resume will be reviewed by our HR department and the team leader of the position you are applying for. After that, we'll send you an email with an explanation of the next round of selection. Your interview will be held online or in person at our office.",
        },
        item3: {
          header: "HR Interview",
          text: "Let's get to know each other. During your interview with the recruiter, we will provide you with a quick overview of our company, culture, and work environment. Along with enhancing your professional career, we will talk about your past employment history, interests, and goals. We will also answer any questions you may have for us.",
        },
        item4: {
          header: "Technical Interview",
          text: "The next step of our process is a technical interview. Depending on the role, you will answer questions about the technology you worked on, complete a task, and have a conversation with our experienced engineers about your project experiences to better evaluate your level of technical skill.",
        },
        item5: {
          header: "Feedback & Offer",
          text: "The last round in our selection process is feedback. You'll get general feedback on your interview. And, of course, if the outcome is positive, we will give you an offer with detailed information about working conditions.<br /><br />We are excited to meet you! ",
        },
      },
    },
    paragraf4: {
      header: "Open <0>Positions</0>",
      text: "If you have any questions you can always contact us at <0>hr@tremium.net</0>. We are more than thrilled to meet you!",
      noOpenPositions: "Currently, we don't have any open possitions. But we'd love to hear from you! Feel free to send your CV or reach out with any questions at <0>hr@tremium.net</0>.",
    },
    positions: {
      item1: {
        header: "<2>Internship</2> <1><0>Full-stack Dev.</0></1>",
        text: "Are you a passionate, driven individual with a desire to kick-start a career in software development? Are you a coding enthusiast with a passion for both front-end flair and back-end brilliance? If so, our Full Stack Developer Internship may be the perfect opportunity for you!",
        workingHours: "FULL-TIME",
        location: "ON-SITE",
      },
      item2: {
        header: "<1><0>Full-stack</0></1><1><0>Developer</0></1>",
        text: "Are you a coding enthusiast, an expert in crafting intuitive user interfaces, and eager to take your skills to the next level? If you have 2+ years of experience in .NET and React, this is your chance to work on an innovative project in a dynamic team.",
        workingHours: "FULL-TIME",
        location: "NIŠ/REMOTE",
      },
    },
  },
  howWeCanHelpPage: {
    intro: {
      header: "For <0>Clients</0>",
      text: "Whether you're a startup developing an MVP, a fast-growing company needing extra support, or an enterprise looking for specialized solutions, <0>we adapt to your needs</0> and cover all phases of software development - from idea and design to launch and scaling.",
      ourWork: "Our Work",
      hireUs: "Hire Us",
    },
    paragraf1: {
      header: "Our <0>Process</0>",
      items: {
        item1: {
          header: "1. Discovery",
          text: "Business Analysis <br /> Solution Design <br />IT Consulting",
          badges: [
            "Product Owner",
            "Product Manager",
            "System Architect",
            "UI/UX Designer",
          ],
        },
        item2: {
          header: "2. Development",
          text: "Software Development <br /> Quality Assurance <br /> DevOps",
          badges: [
            "Software Engineer",
            "QA Engineer",
            "Scrum Master",
            "DevOps Engineer",
            "Project Manager",
          ],
        },
        item3: {
          header: "3. Support",
          text: "System Monitoring <br /> Data Visualization <br /> Reporting",
          badges: [
            "Data Specialist",
            "MLOps Engineer",
            "DevOps Engineer",
            "Support Manager",
          ],
        },
        item4: {
          header: "4. Improvement",
          text: "Al Optimization <br /> Al Development <br /> Business Intelligence",
          badges: [
            "Data Specialist",
            "Al Engineer",
            "Product Owner",
            "System Architect",
            "DevOps Engineer",
          ],
        },
      },
    },
    paragraf2: {
      header: "Let's Talk About <br /><0>Your Ideas</0>",
      items: {
        item1: {
          header: "A startup looking for an agile team?",
          text: "We assist startups in defining their product vision and building MVPs. Our team designs intuitive user interfaces and conducts market tests quickly. From early-stage refinement to market expansion, our scalable solutions are built to support your growth.",
        },
        item2: {
          header: "Fast-growing and need tech support?",
          text: "Looking for specialized solutions, system integrations, or digital products? Our senior engineers create secure, scalable, and high-performing enterprise-grade systems, collaborating closely with your team to meet the needs of complex business environments.",
        },
        item3: {
          header: "A large corporation looking for expert partners?",
          text: "Looking for specialized solutions, system integrations, or digital products? Our senior engineers create secure, scalable, and high-performing enterprise-grade systems, collaborating closely with your team to meet the needs of complex business environments.",
        },
        item4: {
          header: "Need UX/UI design?",
          text: "Our designers create intuitive interfaces, prototypes, and attractive products to give you the best user experience. We focus on designs that put users first, making digital solutions that are functional, engaging, and simple to navigate.",
        },
        item5: {
          header: "Not sure where to start?",
          text: "Get in touch, and let’s find the best solution for your needs!",
        },
      },
    },
  },
  footer: {
    tabs: {
      tab1Label: "Join <0>Tremium</0>",
      tab2Label: "Do Business With <0>Tremium</0>",
    },
    joinUsReasons: [
      "Long-standing relationships",
      "Striving for excellence",
      "Commitment to people",
      "Boldness",
    ],
    doBusinessReasons: [
      "Long-standing relationships",
      "Quality products and services",
      "Reliable processess",
      "Security and confidentiality",
    ],
    joinUsForm: {
      fullName: {
        label: "First and Last Name:",
        name: "Name",
      },
      email: {
        label: "Email:",
        name: "Email",
      },
      attachment: {
        label: "CV:",
        name: "Attachment",
      },
    },
    doBusinessForm: {
      fullName: {
        label: "First and Last Name:",
        name: "Name",
      },
      email: {
        label: "Email:",
        name: "Email",
      },
      company: {
        label: "Company:",
        name: "CompanyName",
      },
    },
    message: {
      text: "The form has been successfully submitted",
      title: "Form submitted",
    },
  },
  privacyPolicyPage: {
    title: "Privacy Policy <br /> for <0>Tremium</0>",
    introText: `<p>Tremium doo is dedicated to adhering to data protection regulations, including those outlined in the <i>General Data Protection Regulation</i> (EU Regulation 2016/679). This privacy policy outlines the personal data we gather, how we utilize it, and the rights you possess regarding your information.</p>`,
    sectionIntroduction: {
      title: "Introduction",
      text: `<p>We highly value your privacy and are committed to safeguarding it through compliance with this <i>Privacy Policy</i>. This <i>Privacy Policy</i> delineates the types of data we may collect from you or that you provide, such as when you visit our websites or interact with us through other means, and how we utilize, protect, and disclose that information.</p>
             <p>This <i>Privacy Policy</i> does not extend to data collected on third-party platforms or applications, including advertisements, that may link to or be accessible from our platforms. We are not accountable for the privacy policies or practices concerning data collection, use, and disclosure on those platforms. We urge you to review the privacy policies of each platform you engage with.</p>
             <p>Kindly peruse this <i>Privacy Policy</i> meticulously to comprehend our policies and procedures regarding your information and how we intend to handle it. By accessing or utilizing any of our services, including our websites and email communications, you agree to this Privacy Policy. This Policy is subject to periodic changes, which may influence how we utilize the information described below. Hence, please revisit the Privacy Policy periodically for updates.</p>
              `,
    },
    sectionHowWeUtilizeAndSafeguardPersonalInformation: {
      title: "How We Utilize and Safeguard Personal Information",
      text: `<p>We collect various types of information for our business operations, including but not limited to:</p>
            <1>
              <2><strong>Information provided by you</strong>: When you interact with our platforms or communicate with us, we may request or you may voluntarily provide certain information, including personally identifiable information such as name, surname, email address, and telephone number. </2>
              <2><strong>Information collected from website forms</strong>: This encompasses information submitted when registering to use segments of our platforms or our products and services, posting content, or requesting additional services. We may solicit information when you report issues with our platforms, products, or services.</2>
              <2><strong>Usage details, IP addresses, and cookies</strong>: As you navigate and engage with our platforms, we may automatically gather specific information about your devices, browsing activities, and patterns using common internet technologies like cookies and web beacons. This may include details of your visits to our platforms, connectivity information such as IP addresses and browser details, geographical data, logs, other communication data, and resources accessed on the platforms. This information aids us in enhancing our platforms and delivering superior and more personalized content and services by enabling us to gauge audience size and usage trends and recognize returning users.</2>
              <2><strong>General business-related information</strong>: We may also receive other personal data from or concerning you as part of our routine business operations.</2>
            </1>
            
            <p>We utilize the information we collect about you or that you provide to us, including personal information, for the following purposes:</p>
            <1>
              <2>Presenting our platforms, products, and services to you and continually enhancing them.</2>
              <2>Furnishing you with information, products, or services that you request from us.</2>
              <2>Notifying you about changes to our platforms, products, or services, including new offerings, promotions, or events.</2>
              <2>Upholding the integrity and security of our platforms, products, and services.</2>
              <2>Facilitating our standard business operations, including human resources, recruitment, business research, and outreach efforts.</2>
            </1>`,
    },
    sectionLegalBasisforDataProcessing: {
      title: "Legal Basis for Data Processing",
      text: `<p>We are only authorized to process personal data if we have a valid legal justification. Consequently, we will only process your data if:</p>
              <1>
                <2>The processing is indispensable to fulfill our contractual obligations to you or to take pre-contractual measures at your behest, such as authenticating your login to our services or ensuring your access is limited to the services and data agreed upon.</2>
                <2>The processing is necessary to adhere to our legal or regulatory obligations, such as tax reporting or regulatory mandates.</2>
                <2>The processing is imperative for the legitimate interests of Tremium doo and does not unduly impinge upon your interests or fundamental rights and freedoms.</2>
                <2>The processing is necessary for the performance of a task carried out in the public interest; or, in certain cases and as requested from time to time, we have obtained explicit consent from you.</2>
              </1>
              <p>If we process any special categories of data concerning you, we do so because:</p>
              <1>
                <2>The data has been explicitly made public.</2>
                <2>The processing is vital for establishing, exercising, or defending a legal claim.</2>
                <2>The processing is crucial for reasons of substantial public interest, or you have explicitly consented to us processing that information (where legally permissible).</2>
              </1>`,
    },
    sectionDisclosureOfYourInformation: {
      title: "Disclosure of Your Information",
      text: `<p>Safeguarding your personal information is paramount to us, and we neither lease nor sell your data to any entity. We may, however, disclose or transfer personal information collected or provided by you under the circumstances outlined in this Privacy Policy, including:</p>
            <1>
              <2>To a purchaser or other successor in the event of a merger, acquisition, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Tremium doo assets, where personal information held by Tremium doo about users of our platforms is included among the assets transferred.</2>
              <2>To our affiliates, agents, contractors, service providers, and other third parties we engage with, who are contractually bound to maintain the confidentiality of personal information and utilize it solely for providing services to or with us.</2>
              <2>To comply with any court order, law, or legal process, including responding to government or regulatory requests.</2>
              <2>To safeguard the rights, property, or security of Tremium doo, our employees, our users, or others.</2>
            </1>`,
    },
    sectionOnwardTransferOfYourInformation: {
      title: "Onward Transfer of Your Information",
      text: `<p>Temium doo is headquartered in Serbia and does not have subsidiaries or affiliates outside of Serbia. We process and store your personal data within Serbia and do not transfer it to entities outside the country unless required by law or with your explicit consent.</p>
            <p>If, in exceptional cases, an international transfer of personal data is necessary, we ensure that appropriate safeguards are in place in accordance with applicable data protection laws. You may request further information regarding such safeguards by exercising your rights as described below.</p>`,
    },
    sectionDataIntegrityAndProportionality: {
      title: "Data Integrity and Proportionality",
      text: `<p> We only collect and retain the amount of personal information necessary for specific, identified purposes as described in this Privacy Policy, and we do not utilize it in any manner incompatible with those purposes.</p>`,
    },
    sectionYourRightsAndHowToExerciseThem: {
      title: "Your Rights and How to Exercise Them",
      text: `<p>You may possess the right to access and obtain a copy of your personal data as processed by Tremium doo. If you believe any information we hold about you is inaccurate or incomplete, you may also request correction of your personal data.</p>
             <p>You may also have the right to:</p>
             <1>
                <2>Object to the processing of your personal data.</2>
                <2>Request the erasure of your personal data.</2>
                <2>Request restrictions on the processing of your personal data; and/or</2>
                <2>Withdraw consent where Tremium doo obtained your consent to process personal data (without affecting the lawfulness of any processing carried out before withdrawal).</2>
             </1>
            <p>We will honor such requests, withdrawals, or objections as applicable data protection regulations mandate. However, these rights are not absolute; they do not invariably apply, and exemptions may be invoked. Typically, we will ask you to verify your identity and/or provide additional information to understand your request better. If we fail to comply with your request, we will explain.</p>
            <p>To exercise the aforementioned rights, you may email us at <strong><3 href="mailto:marketing@tremium.net">marketing@tremium.net</3></strong>. If you are dissatisfied with our handling of your personal data, kindly inform us, and we will investigate your concern.</p>`,
    },
    sectionSecurity: {
      title: "Security",
      text: `<p>We prioritize your security and implement reasonable measures to protect and secure your personal information from unauthorized access, use, and disclosure. We have established adequate technical and organizational safeguards to shield personal data against unauthorized or unlawful destruction, loss, alteration, misuse, disclosure, access, and other unlawful forms of processing. These security measures are implemented considering the state of technology, implementation costs, processing risks, and the nature of the personal data, with particular emphasis on sensitive data.</p>
             <p>Your information's safety and security also rely on you. If you have been provided (or have chosen) a password to access certain sections of our platforms, products, or services, it is your responsibility to keep this password confidential. Kindly refrain from sharing your password with anyone.</p>
             <p>While we strive to maintain the security of information transmitted to us over the Internet, we cannot guarantee or warrant the security of any information you transmit to us. We are not liable for circumvention of any privacy settings or security measures embedded in our platforms.</p>
             <p>If you remain dissatisfied with our response, you possess the right to file a complaint with the data protection authority in your jurisdiction or the jurisdiction where you reside or work, or where you believe a data-related issue has emerged.</p>`,
    },
    sectionDataRetention: {
      title: "Data Retention",
      text: `<p>We will retain personal data only for the duration necessary to fulfill the purposes for which it was collected or to comply with legal, regulatory, or internal policy obligations.</p>`,
    },
    sectionChangesToOurPrivacyPolicy: {
      title: "Changes to Our Privacy Policy",
      text: `<p>We reserve the right to amend this Privacy Policy periodically. We urge you to revisit this page regularly to review the prevailing version of this Policy. If you have any concerns or inquiries about this Policy or wish to file a complaint, kindly contact us.</p>`,
    },
    sectionContactInformation: {
      title: "Contact Information",
      text: `<p>For any queries or remarks regarding this Privacy Policy, please contact us by emailing <strong><3 href="mailto:marketing@tremium.net">marketing@tremium.net</3></strong> or writing to us at:</p>
              <p>
              <strong>
                Božidarčeva 16, VP1<br />
                Niš, Serbia
              </strong>
              </p>
              <p>We value your privacy and are committed to addressing any concerns you may have regarding the handling of your personal information.</p>`,
    },
  },
  ourWorkPage: {
    title: "Our Projects & <0>Case Studies<0>",
    introText:
      "Every challenge presents an opportunity for innovation. We develop digital solutions that achieve actual results by collaborating, gaining deep insights, and thinking boldly. Explore our case studies to see how we transform ideas into success stories while <0>building lasting partnerships</0> along the way.",
    stats: {
      number1: "15+",
      text1: "Years with the Same Clients",
      number2: "50+",
      text2: "Client Projects",
      number3: "100%",
      text3: "Client Retention",
      number4: "5+",
      text4: "Inhouse Projects",
    },
    challengeToSolution: {
      title: "From <0>Challenge</0> to <1>Solution</1>",
      filters: [
        "All",
        "FinTech",
        "Healthcare",
        "Cross-Industry",
        "Travel",
        "Construction",
      ],
      items: {
        item1: {
          header: "<3>Case study</3> <2>Inspect</2> <1><0>Master</0></1>",
          text: "Inspect Master is a web app that streamlines workplace safety inspections. It <0>helps businesses</0> stay compliant, reduce errors, and simplify fieldwork with fast data entry from any device.",
          users: {
            number: "10+",
            label: "Inspect Master Users",
          },
          rate: {
            number: "30%",
            label: "Faster Inspection Process Closure",
          },
          yearsInUse: {
            number: "2",
            label: " Year Project Duration",
          },
          category: "In-House Projects",
          industry: "Construction",
          location: "Serbia",
        },
        item2: {
          header: "<3>Case study</3> <1><0>Financial</0> <br /> Engine</1>",
          text: "Financial Engine offers a comprehensive overview of the client's financial operations, enabling <0>efficient tracking</0> of income and expenses while providing a clearer understanding of cash flow.",
          users: {
            number: "5+",
            label: "Team Members",
          },
          rate: {
            number: "1.6m+",
            label: "Transactions per Year",
          },
          yearsInUse: {
            number: "3+",
            label: "Years Project Duration",
          },
          category: "Client’s Project",
          industry: "FinTech",
          location: "USA",
        },
        item3: {
          header:
            "<3>Case study</3> <2>Precious</2> <1>Metals <0>Trading</0></1>",
          text: "The project included developing new digital platforms and backend support for trading, account management, payment processing, and IRA integration, creating a <0>modern investment experience.</0>",
          users: {
            number: "20+",
            label: "Team Members",
          },
          rate: {
            number: "50k+",
            label: "Users",
          },
          yearsInUse: {
            number: "3+",
            label: "Years Project Duration",
          },
          category: "Client’s Project",
          industry: "FinTech",
          location: "USA",
        },
        item4: {
          header:
            "<3>Case study</3> <1><0>AI Anomaly </0> <br /><0>Detection</0></1>",
          text: "We developed <0>a real-time anomaly detection system</0> for high-volume transactions to prevent fraud, identify misuse, and maintain operational integrity. It detects suspicious patterns and outliers in user behavior.",
          users: {
            number: "5+",
            label: "Team Members",
          },
          yearsInUse: {
            number: "1 M+",
            label: "Transactions per Year",
          },
          category: "In-House project",
          industry: "Cross-Industry",
          location: "Serbia",
        },
        item5: {
          header:
            "<3>Case study</3> <1><0>BI Healthcare</0> <br /> Solution</1>",
          text: "We created a <0>fully customizable business intelligence solution</0> that offers insights into cash flow and workforce management, enabling smarter, faster decision-making.",
          users: {
            number: "7+",
            label: "Team Members",
          },
          rate: {
            number: "100+",
            label: "Users",
          },
          yearsInUse: {
            number: "1,6 M+",
            label: "Transactions per Year",
          },
          category: "Clients Project",
          industry: "Healthcare",
          location: "USA",
        },
        item6: {
          header:
            "<3>Case study</3> <1>Transforming  <br /> <0>Chiropractic</0> <br /> with Data</1>",
          text: "<0>A strong analytics system</0> build to help leaders and clinical teams make data-based decisions.",
          users: {
            number: "3+",
            label: "Team Members",
          },
          rate: {
            number: "150+",
            label: "Clinics",
          },

          category: "Client’s Project",
          industry: "Healthcare",
          location: "USA",
        },
        item7: {
          header: "<3>Case study</3> <2>Slichka</2>",
          text: "Slichka is the <0>all-in-one </0>app for photographers that makes organizing and sharing photos with clients easy. Every image is securely stored in the cloud, while galleries can be shared in just a few clicks.",
          users: {
            number: "3x",
            label: "Faster Workflow",
          },
          rate: {
            number: "70%",
            label: "Less Admin Work",
          },
          yearsInUse: {
            number: "1",
            label: "Years In Development",
          },
          category: "In-House Project",
          industry: "Photography",
          location: "Serbia",
        },
        item8: {
          header: "<3>Case study</3> <2>Turist<0>Master</0></2>",
          text: "TuristMaster is an <0>all-in-one platform</0> for travel agencies and tour operators, designed to keep everything, from offers to invoices, well-organized and in sync.",
          users: {
            number: "5+",
            label: "Team Members",
          },
          rate: {
            number: "90%",
            label: "Success Rate",
          },
          yearsInUse: {
            number: "1+ ",
            label: "Year Project Duration",
          },
          category: "In-House Projects",
          industry: "Travel",
          location: "Serbia",
        },
      },
    },
    yourIdeas: {
      title: "Let's Talk About <br/><0>Your Ideas</0>",
      text: "Contact us to explore how we can provide <0>customized solutions</0> for your business.",
      hireUs: "Hire us",
    },
    help: {
      title: "How We Can <0>Help</0>",
      text: "Find out what we can do for you and how we might be <0>the right solution</0> you've been looking for. Browse through our services and decide if we're the right team to support your journey.",
      checkItOut: "Check it out",
    },
  },
  caseStudies: {
    backButton: "Back to <strong>Case Studies</strong>",
    inspectMaster: {
      banner: {
        header: "Inspect <0>Master</0>",
        text: "Inspect Master is a web application created to <0>simplify workplace safety</0> inspections across various industries. It assists businesses in ensuring compliance with safety regulations while minimizing the risk of human error. ",
        badges: ["In-house project", "Construction", "Serbia"],
      },
      stats: [
        {
          number: "10+",
          text: "Employees on Inspect Master",
        },
        {
          number: "30%",
          text: "Faster Inspection Process Closure",
        },
        {
          number: "2",
          text: "Years in Development",
        },
      ],
      description: {
        header: "Idea & <0>Vision</ 0>",
        paragrafs: {
          paragraf1:
            "A few years ago, one of our long-term partners approached us with a significant challenge that was affecting their daily operations. As a company focused on workplace safety compliance, they were struggling with time-consuming manual inspections, a load of paperwork, and inefficient reporting processes. Conducting thorough safety checks while keeping up with constantly evolving regulations has become a complex and error-prone task.",
          paragraf2:
            "Through in-depth consultations and an exploration of their workflow, we gained a deeper understanding of the core issues they faced. This led to the development of Inspect Master, a web application designed to transform safety inspections. Our goal was simple: eliminate inefficiencies with automation. We created a <0>scalable, all-in-one</0> digital platform that streamlines inspections from planning to compliance management, ensuring adaptability across a range of industries.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `Companies conducting workplace safety inspections encountered several significant challenges: </ br> 
             <1>
                <2>Inspections relied on paper-based checklists and handwritten reports, which slowed down workflows.</2>
                <2>Without a structured system, engineers could overlook critical details or make mistakes in documentation.</2>
                <2>Different engineers used various formats, making it challenging to compare and analyze reports consistently.</2>
                <2>Manually compiling inspection data into professional reports required considerable time and effort.</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `To address these industry-wide challenges, we developed Inspect Master, an all-in-one solution that:
              <1>
                <2>Inspections relied on paper-based checklists and handwritten reports, which slowed down workflows.</2>
                <2>Without a structured system, engineers could overlook critical details or make mistakes in documentation.</2>
                <2>Different engineers used various formats, making it challenging to compare and analyze reports consistently.</2>
                <2>Manually compiling inspection data into professional reports required considerable time and effort.</2>
              </1>
              With Inspect Master, companies can replace outdated manual processes with a modern, automated, and efficient inspection system.
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            number: "70%",
            text: "Fewer Mistakes with Ready-Made Templates",
          },
          result2: {
            number: "3 min",
            text: "Average Report Generation Time",
          },
          result3: {
            number: "50%",
            text: "Less time spent on recurring professional reports",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
      sthForOur: {
        header: "Something from <br/><0>Our Users</0>",
        client: {
          person: {
            name: "Saša Milosavljević",
            position: "Manager at BP Consulting",
          },
          text: "We have been fostering a friendship with the Tremium team for a long time, which we strengthened by working together on a fantastic project. The idea for the project came from our desire to simplify day-to-day tasks. The Tremium team took that idea and improved it with their knowledge and skills to create a feature-rich and truly helpful application. We highly recommend this team of professionals!",
        },
      },
    },
    HAA: {
      banner: {
        header: "Precious Metals <0>Trading</0>",
        text: "The project goal was to <0>centralize operations</0> and enhance user experience through a white-label web portal and mobile app. This included developing new digital platforms and backend support for trading, account management, payment processing, and IRA integration, creating a modern investment experience. ",
        badges: ["Client’s Project", "FinTech", "USA"],
      },
      stats: [
        {
          number: "20+",
          text: "Team Members",
        },
        {
          number: "3+",
          text: "Years Project Duration",
        },
        {
          number: "50k+",
          text: "Users",
        },
      ],
      description: {
        header: "About The <0>Client</ 0>",
        paragrafs: {
          paragraf1:
            "Global Bullion Investments (GBI) is a leading provider of precious metals investment solutions, catering to individual investors and wealth management firms. With an advanced technology platform, GBI simplifies the process of buying, managing, and storing physical precious metals, either directly or through existing wealth management accounts.",
          paragraf2:
            "<0>To modernize its legacy platform,</0> GBI wanted to centralize operations and enhance user experience through a seamless white-label web portal and mobile application. This project included the development of new digital platforms, backend support for trading, account management, payment processing, and IRA integration, along with ongoing system improvements.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `The key challenges included: </ br> 
             <1>
                <2>Replacing a large, outdated legacy platform with modern, mobile-friendly solutions while ensuring a smooth transition that would not disrupt daily operations.</2>
                <2>Managing several complex integrations, such as credit card payment gateways, banking services, search engines, and other external systems.</2>
                <2>Developing a new white-label API that is flexible enough to be integrated with any front-end solution (whether web or mobile) built on any technology stack.</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `The project lacked documentation, requiring a thorough analysis and documentation of all API endpoints and necessary integrations from the ground up. Our solutions included:
              <1>
                <2>Refactoring the legacy system to eliminate architectural dependencies and optimize performance.</2>
                <2>Transitioning from MVC to React for the web application to enhance scalability and responsiveness.</2>
                <2>Implementing new design patterns, biometric authentication, and deep linking to improve user experience and ensure compliance with service-level agreements (SLAs)</2>
                <2>Developing a robust white-label API that facilitated seamless integration across various front-end platforms.</2>
                <2>Creating new test plan documents for quality assurance to guarantee the platform meets rigorous standards.</2>
              </1>
             The new platform provided an improved user experience, better operational performance, and was well-equipped for scaling.
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            number: "300%",
            text: "Increase in the number of registered accounts",
          },
          result2: {
            number: "250%",
            text: "Increase in transaction volumes",
          },
          result3: {
            number: "200%",
            text: "Increase in revenue generation",
          },
          result4: {
            text: "Successfully onboarded multiple brokers onto the platform shortly after launch",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
    },
    financialEngine: {
      banner: {
        header: "Financial <0>Engine</0>",
        text: "The financial engine <0>simplifies financial operations</0> by delivering real-time insights and supporting data-driven decision-making.",
        badges: ["Client’s Project", "FinTech", "USA"],
      },
      stats: [
        {
          number: "5+",
          text: "Team Members",
        },
        {
          number: "3+",
          text: "Years Project Duration",
        },
        {
          number: "2",
          text: "Transactions per Year",
        },
      ],
      description: {
        header: "About The <0>Client</ 0>",
        paragrafs: {
          paragraf1:
            "Our client is a leading company in the precious metals industry. They specialize in trading, storing, and investing in valuable commodities. They approached us to improve their IT infrastructure by developing a new system to monitor and analyze their financial operations. The goal was to help them gain better insights into their finances and make improved decisions.",
          paragraf2:
            "The software <0>we developed offers</0> a comprehensive overview of the client's financial operations, enabling efficient tracking of income and expenses while providing a clearer understanding of cash flow. By ensuring that all financial activities are recorded clearly and intuitively, the solution significantly enhances the client's financial strategy and overall operational efficiency, thereby empowering them to make more informed, data-driven decisions.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `The main challenges we faced included: </ br> 
             <1>
                <2>Integrating custom software into the client's existing IT system which required tailored approaches for each component and a unique integration strategy.</2>
                <2>Meeting tight deadlines, as the client needed immediate functionality to improve their daily financial management processes.</2>
             </1>
             Despite these challenges, our team successfully navigated the complexities and delivered a seamless integration of the new subsystem`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `Our successful project delivery established us as the client's primary software development partner, opening the door to future collaborations and contracts.
              <1>
                <2>We enhanced our expertise in financial management systems and leveraged it to deliver a robust, tailored solution that met the client’s needs.</2>
                <2>Our dedicated approach tackled the immediate challenge and positioned the client for future growth and enhanced financial clarity.</2>                
              </1>
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            text: "Full visibility into the financial flow across the business.",
          },
          result2: {
            text: "Real-time updates with automated notifications to third-party systems.",
          },
          result3: {
            text: "In-depth reporting that enables stakeholders to make data-driven decisions.",
          },
          result4: {
            text: "Efficient tracking of activities, balances, and transactions.",
          },
          result5: {
            text: "Smart insights to optimize cash flow and refine financial strategies.",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
    },
    biHealthcareSolution: {
      banner: {
        header: "<0>BI Healthcare</0> Solution",
        text: "Our client, a leading healthcare provider, approached us to enhance clinician productivity, track patient outcomes, and optimize operations. We created a <0>fully customizable business intelligence solution</0> that offers insights into cash flow and workforce management, enabling smarter, faster decision-making.",
        badges: ["Client’s Project", "Healthcare", "USA"],
      },
      stats: [
        {
          number: "7+",
          text: "Team Members",
        },
        {
          number: "100+",
          text: "Users",
        },
        {
          number: "1.6 M+",
          text: "Transactions per Year",
        },
      ],
      description: {
        header: "About The <0>Client</ 0>",
        paragrafs: {
          paragraf1:
            "Our client is a leading healthcare provider with multiple clinics across the United States. They have implemented a centralized IT system to manage various business functions, which helps track services provided to patients and monitor the working hours of clinicians at all locations.",
          paragraf2:
            "To enhance clinician productivity and gain a comprehensive view of patient progress during the healing process, the healthcare provider aimed at a robust Business Intelligence (BI) solution. The goal of this BI solution is to deliver actionable insights into cash flow management and workforce organization. With <0>full customization</0>, the solution aims to streamline the client's overall business processes",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `The client faced the challenge of developing a BI solution that seamlessly integrated with their existing IT infrastructure without causing operational disruptions. Their main objectives included: </ br> 
             <1>
                <2>Fulfilling all stakeholder requirements.</2>
                <2>Ensuring smooth integration with their IT ecosystem while maintaining data security.</2>
                <2>Providing real-time, accurate data updates.</2>
                <2>Delivering a user-friendly solution that adheres strictly to Microsoft’s technology stack.</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `<1>
                <2>Developed an interactive data visualization system using Power BI, which facilitates intuitive data exploration and analysis.</2>
                <2>Engineered the solution to uncover valuable insights into key operational metrics, enhancing data-driven decision-making.</2>    
                <2>Leveraged Microsoft Azure’s automation capabilities to enhance data reliability, security, and real-time availability, creating a scalable and future-ready system.</2>                 
              </1>
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            text: "Enhanced Data Comprehension: Intuitive visualizations facilitate the rapid interpretation of complex datasets by stakeholders, thereby enabling informed decision-making.",
          },
          result2: {
            text: "Timely and Cost-Effective Execution: The project was completed within the established timeline and budget parameters.",
          },
          result3: {
            text: "Cutting Edge Technology: The solution was developed utilizing the latest Microsoft technologies, which ensures superior performance and security.",
          },
          result4: {
            text: "Comprehensive Data Services: We provided an extensive range of data services, encompassing ETL processes to advanced visualizations, optimizing the client’s data workflows.",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
    },
    medulla: {
      banner: {
        header: "Transforming <0>Chiropractic</0> with Data",
        text: "Medulla came to us with a clear mission: to support the growth of their <0>high-quality chiropractic</0> network by enhancing clinician performance, tracking patient outcomes, and streamlining operations across dozens of clinics nationwide. They needed a robust, <0>real-time analytics framework</0> that would empower leadership and clinical teams to make data-driven decisions at scale.",
        badges: ["Client’s Project", "Healthcare", "USA"],
      },
      stats: [
        {
          number: "3+",
          text: "Team Members",
        },
        {
          number: "150+",
          text: "Clinics",
        },
      ],
      description: {
        header: "About The <0>Client</ 0>",
        paragrafs: {
          paragraf1:
            "As the country's largest privately owned chiropractic organization, Medulla supports two leading providers - Chiro One Wellness Centers and MyoCore Personalized Pain Care - with comprehensive operational services across clinical, legal, HR, marketing, and IT functions.",
          paragraf2:
            "To continue delivering high-quality, evidence-based care across a growing network of clinics, Medulla needed a <0>unified analytics framework</0> that would offer real-time, accurate data to guide both clinical and strategic decisions. We helped them implement a tailored Business Intelligence platform that now provides deep insights into financial performance, clinician productivity, patient outcomes, and operational efficiency.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `The client required a comprehensive Business Intelligence solution that could be seamlessly integrated into their existing IT infrastructure with minimal disruption to ongoing operations. The primary objectives included: </ br> 
             <1>
                <2>Aligning the platform with the needs of diverse stakeholders across clinical and operational teams</2>
                <2>Ensuring seamless integration with current systems while upholding strict data privacy and security standards</2>
                <2>Allowing real-time, reliable access to important performance metrics.</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `We delivered a fully customized Business Intelligence platform that provides:
              <1>
                <2>Detailed insights into cash flow and revenue cycle performance</2>
                <2>Clinician productivity tracking across all locations</2>    
                <2>Patient care metrics to support better outcomes</2>         
                <2>Operational dashboards for leadership transparency</2>            
              </1>
              This solution has not only improved reporting efficiency but it has also become a foundational tool in Medulla’s mission to enrich the lives of patients through exceptional musculoskeletal care.
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            text: "Interactive and user-friendly dashboards were made to help stakeholders interpret complex data, supporting faster, more informed decisions across the organization.",
          },
          result2: {
            text: "The project was executed efficiently, meeting all deadlines and staying within the approved budget, while maintaining quality and scope.",
          },
          result3: {
            text: "The solution is built on the latest Microsoft technologies and guarantees high performance, security, and scalability for future growth.",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
    },
    aiAnomalyDetection: {
      banner: {
        header: "<0>AI Anomaly Detection</0> Solution",
        text: "We have developed a real-time anomaly detection system tailored for high-volume transactional environments to combat fraud, detect misuse, and ensure operational integrity. <0>Built to be adaptable across industries,</0> our solution identifies suspicious patterns and outliers in user behavior, empowering businesses to act instantly and with confidence.",
        badges: ["In-house project", "Cross-Industry", "Global"],
      },
      stats: [
        {
          number: "5+",
          text: "Team Members",
        },
        {
          number: "",
          text: "Real-Time Procesing",
        },
        {
          number: "1 M+",
          text: "Transactions per Year",
        },
      ],
      description: {
        header: "Our Internal <br/> <0>Succes Story</ 0>",
        paragrafs: {
          paragraf1:
            "In response to the increasing demand for real-time insights and fraud prevention across various industries, we developed <0>a scalable anomaly detection framework.</0> Although it can be customized for different sectors, its initial implementation focused on the betting industry, where identifying irregular patterns in user transactions is essential for maintaining operational trust and financial security.",
          paragraf2:
            "This solution analyzes millions of transactions each year, detecting anomalies that may <0>indicate fraud, abuse, or suspicious activity.</0> With real-time data ingestion and automated detection, clients can respond proactively before any damage occurs.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `Our goal was to build a real-time detection system that could: </ br> 
             <1>
                <2>Handle millions of transactions with minimal latency</2>
                <2>Detect subtle and complex user anomalies at scale</2>
                <2>Seamlessly integrate with existing infrastructure (Kafka-based pipelines)</2>
                <2>Be fully adaptable to new industries and use cases</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `<1>
                <2><0><strong>Real-Time Analytics Pipeline:</strong> Implemented using Apache Kafka and Python, this pipeline supports high-throughput, low-latency data processing</0></2>
                <2><0><strong>Advanced Detection Models:</strong> Used unsupervised and semi-supervised machine learning algorithms to identify outliers and evolving patterns.</0></2>    
                <2><0><strong>Modular Architecture:</strong>: The system is designed to be easily adaptable to various sectors, like fintech, healthcare, and logistics.</0></2>         
                <2><0><strong>Data Labeling & Alerting:</strong> Developed automated tagging mechanisms for suspicious events and integrated alert workflows for security teams.</0></2>            
              </1>
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            text: "<strong>Instant Fraud Detection:</strong> The system enables real-time responses to potential threats, significantly minimizing the time taken to act.",
          },
          result2: {
            text: "<strong>Industry-Agnostic Design:</strong> Although built for betting, the core system is flexible enough to support diverse use cases, such as payment fraud and insider threats.",
          },
          result3: {
            text: "<strong>Optimized Operational Oversight:</strong> Custom dashboards and alerts ensure that decision-makers have complete visibility into flagged anomalies.",
          },
          result4: {
            text: "<strong>Robust & Scalable:</strong> The system is prepared to support future growth, new data streams, and increasingly complex detection logic.",
          },
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industrija", "Lokacija"],
          },
          {
            title: "House",
            badges: ["Clinet project", "Industrija", "Lokacija"],
          },
        ],
      },
    },
    slichka: {
      banner: {
        header: "<0>Slichka</0>",
        text: "Slichka is a web application that streamlines <0>photo ordering and production</0>, enabling clients to browse and purchase photos with ease.",
        badges: ["In-house project", "Photography", "Serbia"],
      },
      stats: [
        {
          number: "3x",
          text: `Faster\nWorkflow`,
        },
        {
          number: "70%",
          text: "Less Admin Work",
        },
        {
          number: "1",
          text: "Years in Development",
        },
      ],
      description: {
        header: "Idea & <0>Vision</ 0>",
        paragrafs: {
          paragraf1:
            "Photographers often lose valuable time on repetitive tasks such as sending large files, responding to emails, managing orders manually, and handling communication with clients. Slichka was created with a goal <0>to simplify and modernize</0> how photographers deliver, share, and sell their work. By automating the entire post-shoot workflow, Slichka allows photographers to spend more time focusing on their work and <0>less on administrative tasks</0>, while providing clients with a more straightforward way to choose from numerous photos.",
          paragraf2:
            "Our main vision behind Slichka is to create an app that offers <0>a smarter way to run a photography business</0>. With all photos securely stored in the cloud, organized in one place, and protected by watermarks, photographers maintain control while delivering an effortless buying experience to their clients. Whether it's a wedding, a school event, or a corporate shoot, Slichka transforms every gallery into a polished, professional, and profitable experience.",
        },
      },
      businessChallenges: {
        header: "Business <0>Challenges</ 0>",
        text: `
             <1>
                <2>Photographers and studios that manage client photo deliveries and sales often face several common challenges that complicate their work.</2>
                <2>After each shoot, photographers can spend hours or even days sorting through photos, sending links to files, answering client inquiries, and processing manual orders.</2>
                <2>Communication with clients can be lengthy, often resulting in confusion, missed messages, or delayed orders, which may lead to lost sales opportunities.</2>
                <2>Sharing high-resolution photos with clients without adequate protection can result in unauthorized downloads, allowing clients to access images without purchasing them.</2>
                <2>Additionally, photos are often scattered across various hard drives, USB drives, and different platforms, with files shared via temporary links, making long-term organization and access problematic.</2>
             </1>`,
      },
      ourSolutions: {
        header: "Our <0>Solutions</0>",
        text: `<1>
                <2><0>Slichka automates the workflow from uploading photos to delivery, reducing administrative tasks by 70%.</0></2>
                <2><0>Each client gets their own gallery where they can view, select, and order photos for printing, even on mobile devices.</0></2>    
                <2><0>To protect photos, Slichka reduces their quality and adds a visible watermark, preventing unauthorized downloads and sharing.</0></2>         
                <2><0>All photos are securely stored in the cloud, making them always accessible and organized by event and client, eliminating the need to juggle between multiple tools.</0></2>            
              </1>
        `,
      },
      theResults: {
        header: "The <0>Results</0>",
        results: {
          result1: {
            number: "60%",
            text: "More completed photo orders with a simplified process compared to traditional manual methods.",
          },
          result2: {
            text: "Slichka is an all-in-one app that combines organization, sharing, and sales into a seamless experience for both photographers and their clients",
          },
          result3: {
            number: "3x",
            text: "Faster workflow for photographers as they no longer need to send files, compile emails, or chase payments.",
          },
        },
      },
      sthForOur: {
        header: "Something from <br/><0>Our Users</0>",
        client: {
          person: {
            name: "Zoran Zdravković",
            position: "SkyTouch",
          },
          text: "As a professional photographer, I find Slichka to be one of the best solutions for working with clients. The application is intuitive and easy to use, saving a significant amount of time. Clients can easily access galleries, select their photos, and directly order high-resolution prints. Slichka has allowed me to work more professionally, modernly, and efficiently, and my clients are thrilled with the results. I highly recommend Slichka to any photographer looking to improve their business and offer additional benefits to their clients.",
        },
      },
      moreStories: {
        header: "More Success <0>Stories</0>",
        stories: [
          {
            title: "Slichka",
            badges: ["In-house project", "Industry", "Location"],
          },
          {
            title: "TravelMaster",
            badges: ["In-house project", "Industry", "Location"],
          },
          {
            title: "House",
            badges: ["Client project", "Industry", "Location"],
          },
        ],
      },
    },
  },
  positions: {
    position1: {
      banner: {
        header: "<0>Full Stack Developer</0> Internship",
        text: "Are you a coding enthusiast with a passion for both front-end flair and back-end brilliance? If you're ready to turn your tech aspirations into reality, we have the <0>perfect opportunity for you!</0>",
        badges: ["Full Time", "Remote/Niš"],
      },
      whatYouWillDo: {
        header: "What You'll <0>Do</0>",
        text: `
              <1>
                <2>Collaborate with our dynamic dev team on cutting-edge projects</2>
                <2>Craft seamless user interfaces and robust back-end functionalities</2>
                <2>Debug and optimize code to enhance performance</2>
                <2>Engage in brainstorming sessions and contribute fresh ideas</2>
                <2>Learn from senior developers and grow your skill set</2>
             </1>
             `,
      },
      whatWeAreLookingFor: {
        header: "What We're <0>Looking For</0>",
        text: `
          <1>
            <2>Currently pursuing or recently completed a degree in Computer Science, Engineering, or a related field</2>
            <2>Basic knowledge of back-end technologies like C# and .NET</2>
            <2>Understanding of JavaScript, HTML, CSS, and React</2>
            <2>Familiarity with database SQL</2>
            <2>Eagerness to learn, adapt, and thrive in a fast-paced environment</2>
            <2>Excellent communication skills and a team-player attitude</2>
          </1>
        `,
      },
      whatsInItForYou: {
        header: "What's In It <0>For You</0>",
        text: `
        <1>
            <2>Real-world experience with impactful projects</2>
            <2>Mentorship from industry experts</2>
            <2>Support in your personal and professional growth</2>
            <2>Modern office</2>
            <2>Flexible working hours</2>
            <2>Potential for professional growth and personal development</2>
            <2>Fun team events!</2>
          </1>
        `,
      },
      aboutUs: {
        header: "Who Are <0>We</0>",
        paragraphs: [
          {
            text: "We are an IT company based in Nis, dedicated to engineering high-quality software that boldly pushes the boundaries of technological innovation. Our work culture fosters boldness, teamwork, continuous learning, and commitment to people.",
            listItems: [
              "We value ideas.",
              "We support proactivity.",
              "We reward team spirit and dedication.",
              "We celebrate successes.",
              "We encourage personal and professional growth.",
            ],
          },
        ],
      },
      applyNow: {
        text: "<0>Ready to embark on your Fullstack adventure</0><br />Boldly Beyond Boundaries!",
      },
    },
    position2: {
      banner: {
        header: "<0>Full Stack</0> Developer",
        text: "We seek <0>passionate and experienced</0> full stack developers to join our dynamic team! If you are a coding enthusiast, an expert in crafting intuitive user interfaces, and aspire to be part of innovative projects, this is the perfect opportunity for you!",
        badges: ["Full Time", "Remote/Niš"],
      },
      whatYouWillDo: {
        header: "You <0>Will</0>",
        text: `
              <1>
                <2>Have the opportunity to bring your skills as a full-stack developer to various projects and products</2>
                <2>Be involved in full project development, from writing a specification to deploying a finished product</2>
                <2>Work with the latest technologies, collaborate with talented colleagues, and significantly impact the development of the products</2>
             </1>
             `,
      },
      whatWeAreLookingFor: {
        header: "You Will Have <0>A Chance To</0>",
        text: `
          <1>
            <2>Design, develop, and maintain scalable web applications across the full technology stack</2>
            <2>Work on both frontend and backend components to ensure seamless data flow</2>
            <2>Build and integrate RESTful APIs</2>
            <2>Integrate existing solutions with 3rd party services</2>
            <2>Collaborate closely with UX/UI designers to deliver intuitive user experiences</2>
            <2>Write clean, maintainable, and testable code following best practices</2>
            <2>Identify performance bottlenecks, optimize application performance, scalability, and security</2>
            <2>Participate in code reviews, knowledge sharing, and continuous improvement initiatives</2>
            <2>Contribute to architectural decisions and technical discussions</2>
          </1>
        `,
      },
      whatsInItForYou: {
        header: "<0>Required </0> Skills <br /> And Qualifications",
        text: `
        <1>
            <2>2+ years of experience using .NET stack and React</2>
            <2>Good software development fundamentals and knowledge of .NET architecture concepts & patterns</2>
            <2>Solid knowledge of developing RESTful APIs</2>
            <2>Good knowledge of relation databases and database design (MSSQL, MySQL)</2>
            <2>Experience in writing Unit Tests</2>
            <2>Proficient in JavaScript, HTML, CSS</2>
            <2>Experience in Redux</2>
            <2>Experience with Git version control system, Bitbucket or GitHub</2>
            <2>Ensure code quality, maintain code organization, and continuously update and enhance existing systems</2>
            <2>Proficiency in English</2>
            <2>Strong analytical and problem-solving skills</2>
            <2>Effective collaboration and communication skill</2>
          </1>
        `,
      },
      niceToHaveSkills: {
        header: "<0>Nice To Have</0> Skills",
        text: `
          <1>
            <2>Good knowledge of software design patterns</2>
            <2>Experience in working with microservices</2>
            <2>Experience with 3rd-party APIs</2>
            <2>Knowledge of other frontend technologies (ex., Vue, Angular)</2>
            <2>Familiarity with Postman</2>
            <2>Experience with some ticketing tools (Azure, JIRA, GitLab…)</2>
            <2>Setting up project structure and architecture</2>
            <2>Basic knowledge of creating user-friendly and visually appealing interfaces</2>
            <2>Basic knowledge of SCRUM methodology</2>
          </1>
        `,
      },
      whatWeOffer: {
        header: "What <0>We Offer</0>",
        text: `
          <1>
            <2>Flexible working hours</2>
            <2>Hybrid working environment</2>
            <2>Daily food coupons</2>
            <2>Modern office</2>
            <2>Private health insurance</2>
            <2>Support in your personal and professional growth</2>
            <2>Lots of team activities and perks</2>
            <2>The dynamic and friendly work environment that values boldness and creativity</2>
            <2>The chance to work on interesting projects</2>
          </1>
        `,
      },
      aboutUs: {
        header: "About <0>Us</0>",
        paragraphs: [
          {
            text: "We are an IT company based in Nis, dedicated to engineering high-quality software that boldly pushes the boundaries of technological innovation. Our work culture fosters boldness, teamwork, continuous learning, and commitment to people.",
            listItems: [
              "We value ideas.",
              "We support proactivity.",
              "We reward team spirit and dedication.",
              "We celebrate successes.",
              "We encourage personal and professional growth.",
            ],
          },
        ],
      },
      applyNow: {
        text: "<0>Let's Code Together</0><br />Boldly Beyond Boundaries!",
      },
    },
  },
};
